import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot";
import axios from "axios";

export const getSiteList = createAsyncThunk('/thunk/get-site-list', async () => {
    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/utils/app/v1/get-site-list`,{page:1})
        console.log("responsePro",response)
        return response
    } catch (error) {
        throw error
    }});